const hexToRgb = (hexColor: string): { r: number; g: number; b: number } | null => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shortHandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexColor.replace(shortHandRegex, function (r, g, b) {
    return r + r + g + g + b + b;
  });

  const longRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
  const result = longRegex.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

const HUE_SATURATION_PERCEIVED_BRIGHTNESS_THRESHOLD = 16256;
const RED_THRESHOLD = 0.299;
const GREEN_THRESHOLD = 0.587;
const BLUE_THRESHOLD = 0.114;

// Darel Rex Finley @ https://alienryderflex.com/hsp.html
export const isDarkColor = (color: string): boolean => {
  if (color.startsWith("#")) color = color.substring(1);
  const rgb = hexToRgb(color);
  if (!rgb) return false;
  const { r, g, b } = rgb;

  const hsp = RED_THRESHOLD * (r * r) + GREEN_THRESHOLD * (g * g) + BLUE_THRESHOLD * (b * b);

  return hsp < HUE_SATURATION_PERCEIVED_BRIGHTNESS_THRESHOLD;
};
